export default [
  { value: 'earlyMorning', submitValue: 'EARLY_MORNING', text: 'appointmentTimeEarlyMorning' },
  { value: 'lateMorning', submitValue: 'LATE_MORNING', text: 'appointmentTimeLateMorning' },
  { value: 'earlyAfterNoon', submitValue: 'EARLY_AFTER_NOON', text: 'appointmentTimeEarlyAfterNoon' },
  { value: 'lateAfterNoon', submitValue: 'LATE_AFTER_NOON', text: 'appointmentTimeLateAfterNoon' }
]
